/**
 * Public API ng-packgr
 */
export const VERSION = '7.1.0-beta.18';
